@if (deviceInfoMatchesLogo()) {
  <div
    [ngClass]="
      withLeftDivider()
        ? 'border-start h-100 d-flex align-items-center ps-2'
        : ''
    "
  >
    <a
      [href]="logo().url"
      class="logo"
      [attr.aria-label]="logo().description"
      [target]="logo().target"
      wlTrackLink
      [trackLinkInfo]="{
        rendering: { componentName: 'NavigationEcmpLogoComponent' },
        field: logo().description,
        eventType: 'link-click',
        type: 'image',
      }"
    >
      <img [src]="logo().logo" alt="" />
    </a>
  </div>
}
